/**
 * Client time-zone evidence for click-through acceptance capture.
 *
 * At every legal acceptance (signup, seat activation, re-acceptance) the app
 * reports the browser's IANA time zone and UTC offset so the recorded evidence
 * can reconstruct the user's local wall-clock time — part of the enforceable
 * acceptance record the served contracts promise. Both fields are optional
 * end-to-end; if the browser can't resolve them, the backend records NULL.
 */
type ClientTimezone = {
  client_timezone?: string;
  client_utc_offset_minutes?: number;
};

export function clientTimezone(): ClientTimezone {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // getTimezoneOffset() returns the minutes the local zone is BEHIND UTC
    // (positive west of UTC). Negate it to express a conventional signed UTC
    // offset (e.g. New York in summer → -240).
    const offset = -new Date().getTimezoneOffset();
    return {
      client_timezone: tz || undefined,
      client_utc_offset_minutes: Number.isFinite(offset) ? offset : undefined,
    };
  } catch {
    // Intl unavailable or blocked — record nothing rather than fail acceptance.
    return {};
  }
}
